import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ObjectsIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 1.5 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Stacked layers/objects icon */}
      {/* Bottom layer */}
      <path
        d="M12 21l-8-4.5v-5L12 16l8-4.5v5L12 21z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        fill="none"
      />
      {/* Middle layer */}
      <path
        d="M4 11.5L12 7l8 4.5"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        fill="none"
      />
      {/* Top layer */}
      <path
        d="M4 7L12 3l8 4"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        fill="none"
      />
    </BaseIcon>
  ),
);

ObjectsIcon.displayName = 'ObjectsIcon';
